export default "__VITE_ASSET__Dp7dQ7oO__"